import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import EmpresaWizard from './EmpresaWizard';
import { useSEO } from '../../hooks/useSEO';

const LOGO_DARK = "https://customer-assets.emergentagent.com/job_precision-connect/artifacts/lvo1u53w_image.png";

export default function EmpresaRegistroPage() {
  useSEO({
    title: 'Iniciar Mandato | Conadvy',
    description: 'Inicie un mandato de asesoramiento estratégico. Proceso confidencial, estructurado y basado en criterio.',
    path: '/empresa/registro',
  });
  const navigate = useNavigate();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div data-testid="empresa-registro-page" className="min-h-screen bg-[#F8F8F6]">
      {/* Minimal header */}
      <header className="fixed top-0 left-0 right-0 z-50 bg-white/95 backdrop-blur-sm border-b border-[#E4E6EA]">
        <div className="max-w-7xl mx-auto px-6 md:px-12 flex items-center justify-between h-16">
          <a href="/" onClick={(e) => { e.preventDefault(); navigate('/'); }} data-testid="wizard-header-logo">
            <img src={LOGO_DARK} alt="Conadvy" className="h-10 object-contain" />
          </a>
          <button
            onClick={() => navigate('/empresa')}
            data-testid="wizard-exit-btn"
            className="text-[#00163E]/50 hover:text-[#00163E] text-sm tracking-wide transition-colors"
          >
            Guardar y salir
          </button>
        </div>
      </header>

      <section className="pt-24 pb-16 md:pt-28 md:pb-20">
        <EmpresaWizard />
      </section>
    </div>
  );
}
